module.exports = __webpack_public_path__ + "9d311fa0354c386a7bbfb41aecd994de.png";